export const rewardRoutes = [
    {
        title: "Расчетный лист",
        description: "Расчетный лист работника с пояснительной информацией",
        path: "/main/hr-services/reward/payroll",
    },
];
